<template>
  <div class="tree-panel">
    <tree-node
      v-for="node in nodes"
      :key="node.id"
      :node="node"
      :level="0"
      :selected="selection"
      @expand="expandNode"
      @select="selectNode"
    />
  </div>
</template>

<script>
import TreeNode from "./TreeNode";

export default {
  components: {
    TreeNode,
  },
  props: {
    items: Array,
    selection: Number,
  },
  data() {
    return {
      nodes: this.items || [],
    };
  },
  watch: {
    items(val) {
      this.nodes = val;
    },
  },
  methods: {
    expandNode(node) {
      node.expand = !node.expand;
    },
    selectNode(node) {
      this.$emit("select", node);
    },
  },
};
</script>

<style>
.tree-node__level0 > .tree-node__item {
  padding-left: 30px;
  position: relative;
  font-size: 16px;
  font-weight: 600;
}

.tree-node__level1 > .tree-node__parent {
  padding-left: 20px;
  position: relative;
  font-size: 14px;
  font-weight: 600;
}

.tree-node__level2 > .tree-node__item {
  padding-left: 15px;
  position: relative;
  font-size: 12px;
  font-weight: 400;
}

.tree-node__toggle {
  display: inline-block;
  width: 12px;
  height: 12px;
  position: absolute;
  left: 4px;
  top: 50%;
  margin-top: -6px;
  background-size: contain;
  background-repeat: no-repeat;
  transition: transform 0.3s;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill='%237f7f7f' d='M3 2.16666667L6.72972973 6 3 9.83333333 4.13513514 11 9 6 4.13513514 1z' fill-rule='evenodd'/%3e%3c/svg%3e");
  transform: rotate(90deg);
}

.tree-node {
  position: relative;
}

.tree-node.closed .tree-node__toggle {
  fill: #ccc;
  transform: rotate(0);
}
.tree-node__text {
  display: block;
  padding-top: 10px;
  padding-bottom: 10px;
  transition: color 0.3s;
}
.tree-node__text:hover {
  color: #888;
}
.tree-node__children {
  margin-top: -4px;
}
.tree-node__children > .tree-node > .tree-node__parent {
  margin-left: -15px;
}
.tree-node.closed .tree-node__children {
  display: none;
}
.tree-node__level0 > .tree-node__children > .tree-node {
  padding-left: 40px;
}
.tree-node__children .tree-node__text {
  padding: 4px 0;
}
.tree-node.active .tree-node__text,
.tree-node.active .tree-node__text:hover {
  color: var(--color-primary);
}
.tree-node__children .tree-node.active .tree-node__text:before {
  content: "";
  display: block;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background-color: var(--color-primary);
  position: absolute;
  top: 13px;
  left: 32px;
}
.tree-node__children .tree-node__level2.active .tree-node__text:before {
  left: 5px;
}
.tree-node__link {
  display: block;
}
</style>